import { throttle } from 'lodash';
import { useLayoutEffect, useEffect, useRef, useState } from 'react';
const REFLOW_CAP = 400;
const getInitialBreakpointValue = () => {
    // get initial breakpoint is called before the page is fully loaded and innerWith may be 0. windows.mqObj may not be set
    var _a;
    const mediaQueries = window.mqObj;
    const documentWidth = window.innerWidth || ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width);
    if (documentWidth == 0 || !mediaQueries) {
        return;
    }
    const filtered = Object.keys(mediaQueries).filter((key) => mediaQueries[key] <= documentWidth);
    const initalBr = filtered.length ? mediaQueries[filtered[filtered.length - 1]] : mediaQueries['xs'];
    // console.info('[getInitialBreakpointValue]: ', documentWidth, initalBr);
    return initalBr;
};
const getReflowValue = () => {
    var _a;
    const documentHeight = window.innerHeight || ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height);
    if (documentHeight == 0) {
        return;
    }
    return documentHeight < REFLOW_CAP ? 399 : REFLOW_CAP;
};
const mediaQueries = Object.assign({ '<xs': 0 }, window.mqObj);
const useMediaQueries = () => {
    const [breakpoint, setBreakpoint] = useState(getInitialBreakpointValue());
    const [breakpointHeight, setBreakpointHeight] = useState(getReflowValue());
    const [isTouch, setIsTouch] = useState(false);
    // const [isMotionReduced, setIsMotionReduced] = useState<boolean>(false);
    const firstRender = useRef(true);
    function detectTouchscreen() {
        if (window.PointerEvent && 'maxTouchPoints' in navigator) {
            // if Pointer Events are supported, just check maxTouchPoints
            if (navigator.maxTouchPoints > 0) {
                setIsTouch(true);
            }
        }
        else {
            // no Pointer Events...
            if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
                // check for any-pointer:coarse which mostly means touchscreen
                setIsTouch(true);
            }
            else if (window.TouchEvent || 'ontouchstart' in window) {
                // last resort - check for exposed touch events API / event handler
                setIsTouch(true);
            }
        }
    }
    const getCurrentBreakpoint = () => {
        var _a;
        const documentWidth = window.innerWidth || ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width);
        if (documentWidth == 0) {
            return;
        }
        const filtered = Object.keys(mediaQueries).filter((key) => mediaQueries[key] <= documentWidth);
        return mediaQueries[filtered[filtered.length - 1]];
    };
    useEffect(() => {
        if (firstRender.current) {
            // setBreakpoint(window.innerWidth);
            firstRender.current = false;
            detectTouchscreen();
        }
    }, []);
    useLayoutEffect(() => {
        const handleResize = throttle(() => {
            const currentBr = getCurrentBreakpoint();
            if (currentBr && currentBr !== breakpoint) {
                setBreakpoint(currentBr);
            }
            const currentHBr = getReflowValue();
            if (currentHBr && currentHBr !== breakpointHeight) {
                setBreakpointHeight(currentHBr);
            }
        }, 200);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint, breakpointHeight]);
    return {
        //@ts-ignore disable-next-line
        isTightMobile: breakpoint <= window.mqObj.xs,
        //@ts-ignore disable-next-line
        isMobile: breakpoint < window.mqObj.lg,
        //@ts-ignore disable-next-line
        isTablet: breakpoint >= window.mqObj.sm && breakpoint < window.mqObj.lg,
        //@ts-ignore disable-next-line
        isSmallDesktop: breakpoint >= window.mqObj.md,
        //@ts-ignore disable-next-line
        isDesktop: breakpoint >= window.mqObj.lg,
        //@ts-ignore disable-next-line
        isWideDesktop: breakpoint >= window.mqObj.xxl,
        isTouch: isTouch,
        isReflow: breakpointHeight < REFLOW_CAP,
    };
};
export default useMediaQueries;
